import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit'
import '@rainbow-me/rainbowkit/styles.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { WagmiProvider } from 'wagmi'
import { App } from './App'
import { ApiClientError } from './api/client'
import { wagmiConfig } from './lib/wagmi'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A quote is a live number; nothing about it is worth reusing across a remount.
      staleTime: 0,
      retry: (failureCount, error) => {
        // Retrying NO_ROUTE or UNKNOWN_TOKEN asks the same question and spends the same
        // node budget for the same answer. Only the operational failures are retried.
        if (error instanceof ApiClientError) return error.isTransient && failureCount < 1
        return failureCount < 1
      },
    },
  },
})

const container = document.getElementById('root')
if (!container) throw new Error('#root is missing from index.html')

createRoot(container).render(
  <StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={darkTheme({ accentColor: '#ff6b2c', borderRadius: 'medium' })}>
          <App />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </StrictMode>
)
